module.exports = __webpack_public_path__ + "media/images/company/cp03-0b3ba4a807eb03e080f037cb4abec816.png";